import { faCheck, faPen, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useOutletContext } from "react-router";
import { Consts } from "../Consts";
import noProfilePhotoIcon from "../assets/no-profile-photo.png";
import { localizeState } from "../utils/registrationRenderHelpers";

export function OnSite() {
  const {event} = useOutletContext()
  const [regs, setRegs] = useState(null)
  const [lunchEditors, setLunchEditors] = useState({})

  async function parseJsonSafe(response) {
    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  function setLunch(index, value) {
    lunchEditors[index] = value;
    setLunchEditors({...lunchEditors});
  }

  async function insertOrUpdateRegistration(userId, newValue) {
    const response = await fetch(`${Consts.baseUrl}api/event-registrations/adminRegister/${localStorage.getItem("event")}/${userId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: newValue,
    });

    const responseBody = await parseJsonSafe(response);
    if (!response.ok || !responseBody?.registration) {
      console.error("insertOrUpdateRegistration failed", response.status, responseBody);
      alert(responseBody?.error?.message ?? "Nem sikerült menteni a státuszt.");
      return;
    }

    if (responseBody?.crmSyncSuccessful === false) {
      alert("Státusz mentve, de a CRM szinkron nem sikerült. A rendszer automatikusan újrapróbálja.");
    }

    setRegs(previousRegs => {
      if (!previousRegs) return previousRegs;
      const nextRegs = [...previousRegs];
      const regIndex = nextRegs.findIndex(r => r.user.id === userId);
      if (regIndex >= 0) {
        nextRegs[regIndex] = {
          ...nextRegs[regIndex],
          state: responseBody.registration.state,
          online: responseBody.registration.online,
        };
      } else {
        nextRegs.push(responseBody.registration);
      }
      return nextRegs;
    });
  }
  async function saveLunch(index) {
    const rawLunch = lunchEditors[index];
    const lunch = rawLunch === "true" ? true : rawLunch === "false" ? false : rawLunch;

    const response = await fetch(
      Consts.baseUrl + "api/event-registrations/update/" + index,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({
          lunch: lunch
        })
      }
    );

    if (!response.ok) {
      const responseBody = await parseJsonSafe(response);
      console.error("saveLunch failed", response.status, responseBody);
      alert(responseBody?.error?.message ?? "Nem sikerült menteni az ebéd státuszt.");
      return;
    }

    await updateRegistrations();
    lunchEditors[index] = undefined;
    setLunchEditors({...lunchEditors});
  }

  useEffect(() => {
    updateRegistrations()
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      updateRegistrations()
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  const updateRegistrations = async () => {
    const response = await fetch(Consts.baseUrl + "api/event-registrations/byevent/"+localStorage.getItem('event')+"/Appeared", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      },
    });

    if (!response.ok) {
      const responseBody = await parseJsonSafe(response);
      console.error("updateRegistrations failed", response.status, responseBody);
      return;
    }

    const responseBody = await parseJsonSafe(response);
    setRegs(Array.isArray(responseBody) ? responseBody : []);
  }

  if(!regs || !event)
    return (
      <div className="spinner-border" role="status" style={{"--bs-spinner-width": "5rem", "--bs-spinner-height": "5rem", "--bs-spinner-border-width": "0.5em"}}>
        <span className="visually-hidden">Loading...</span>
      </div>
    )

  return (
    <div className="row wrapper">
      <div className="col-6">
        <h2>HELYSZÍNEN MEGJELENTEK:</h2>
        <table className="onsite mtop25 table table-bordered table-striped">
          <thead>
            <tr>
              <th scope="col">Státusz</th>
              <th scope="col">Fotó</th>
              <th scope="col">Név</th>
              <th scope="col">Cégnév</th>
              <th style={{
                display:
                  !event?.addresses?.find(
                    (a) => !a.location || a.location === ""
                  ) && "none",
              }} scope="col">Online</th>
              <th style={{ display: !event.lunch && "none" }} scope="col">Ebéd</th>
              <th scope="col">Ütközés ID</th>
            </tr>
          </thead>
          <tbody>
          {
            regs ? regs?.map((r, index) => {
              return (
                <tr key={index}>
                  <th scope="row">
                    <Dropdown onSelect={(eventKey) => insertOrUpdateRegistration(r.user.id, eventKey)}>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {localizeState(r.state, event.addresses.some(a => !a.location || a.location === "") && r.online)}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Registered", online: false})}>Biztos jön</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Canceled"})}>Lemondta</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Appeared", online: false})}>Megjelent</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Waiting"})}>Várólista</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Interested"})}>Érdeklődő</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Applied"})}>Jelentkezett</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Denied"})}>Elutasított</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "WontAttend"})}>Biztos nem jön</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "NotAppeared", online: false})}>Nem jelent meg</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Registered", online: true})}>Biztos jön - online</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Appeared", online: true})}>Megjelent - online</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "NotAppeared", online: true})}>Nem jelent meg - online</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </th>
                  <td className="imgwrapper" scope="row"><img src={ r.user.picture?.url ? Consts.baseUrl + r.user.picture.url.slice(1) : noProfilePhotoIcon } ></img></td>
                  <td>{r.user.lastName} {r.user.firstName}</td>
                  <td>{r.user.company?.name ?? "Nincs cég megadva"}</td>
                  <td style={{
                    display:
                      !event?.addresses?.find(
                        (a) => !a.location || a.location === ""
                      ) && "none",
                  }} scope="col">{r.online ? 'Igen':'Nem'}</td>
                  <td style={{ display: !event.lunch && "none" }} scope="col">
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
                      { lunchEditors[r.id] === undefined ?
                          <div style={{width: 100}}>{r.lunch ? "Igen" : "Nem"}</div> :
                          <div style={{width: 100}}>
                            <select value={lunchEditors[r.id]} onChange={event => setLunch(r.id, event.target.value)} style={{width: '100%'}}>
                              <option value="true">Igen</option>
                              <option value="false">Nem</option>
                            </select>
                          </div>
                      }
                      { lunchEditors[r.id] === undefined ?
                          <FontAwesomeIcon icon={faPen} onClick={() => setLunch(r.id, r.lunch ?? false)} style={{marginLeft: 20}} /> :
                          <div style={{display: "flex"}}>
                            <FontAwesomeIcon icon={faCheck} onClick={() => saveLunch(r.id)} style={{marginLeft: 20}} />
                            <FontAwesomeIcon icon={faXmark} onClick={() => setLunch(r.id, undefined)} style={{marginLeft: 5}} />
                          </div>
                      }
                    </div>
                  </td>
                  <td style={{ textAlign: "center" }} >{r.user?.company?.reservationConflictId}</td>
                </tr>)
            }) : <div>Nincs még helyszínen megjelent személy</div>
          }
          </tbody>
        </table>
      </div>
    </div>
  )
}
